<template>
    <b-container class="workshopSidebar px-4 bg-white">

        <tunnel-popup />

        <div id="intro-sidebar" class="mb-4">
            <h1 class="font-weight-bold h2"><t wsSidebar.title /></h1>
            <p><t wsSidebar.intro /></p>
        </div>

        <properties-box />

        <transition-group name="bounce">
            <errors-box v-if="autoCorrectsList" key="error-box" />
        </transition-group>

        <add-to-cart />
    </b-container>
</template>

<script>
    /* eslint-disable vue/no-unused-components */
    import { mapGetters } from 'vuex';
    import { BContainer, BRow, BCol, BFormSelect, BFormGroup, BMedia, BMediaAside, BMediaBody, BCard, BIcon, BIconCaretDownFill, BIconColumnsGap, BIconArrowLeftCircleFill, BDropdown, BDropdownItem, BDropdownForm, BDropdownItemButton, BDropdownGroup, BButton } from 'bootstrap-vue'
    import TunnelPopup from './TunnelPopup.vue';
    import PropertiesBox from './PropertiesBox.vue';
    import MaterialsChoice from './MaterialsChoice.vue';
    import AddToCart from './AddToCart.vue';
    import ErrorsBox from './ErrorsBox.vue';
    

    export default {
        components: { BContainer, BRow, BCol, BFormSelect, BFormGroup, BMedia, BMediaAside, BMediaBody, BCard, BIcon, BIconCaretDownFill, BIconColumnsGap, BDropdown, BDropdownItem, BDropdownForm, BDropdownItemButton, BDropdownGroup, BButton, BIconArrowLeftCircleFill, MaterialsChoice, TunnelPopup, AddToCart, PropertiesBox, ErrorsBox },

        data(){
            return {
                currentStep: null,
                products: [],
                thicknesses: [],
                cuttingparams: [],
                dataLoaded: false,
                isReturned: false
            }
        },
        ready: function() {
            this.step = this.nextStep();
        },

        methods: {
            hideModal() {
                this.$refs['modal-1'].hide();
            },
            submit() {
                this.$store.dispatch('submit');
            }
        },

        computed: {
            ...mapGetters([
                'autoCorrectsList'
            ]),
        },
    }
</script>

<style lang="scss">
    @import "~animate.css/source/animate.css";
    @import './../../assets/scss/_variables.scss';

    .workshopSidebar {
        h1,
        p {
            color: $gristext;
        }

        overflow: scroll;
        height: 100vh;
    }

    .return {
        left: -42px;
        color: $white!important;
        border-radius: 100%;

        &:hover {
            color: $jaune;
        }

        @media (max-width: 767px) {
            top: -40px;
            left: 3px;
        }
    }

    .thumbnail {
        svg {
            width: 7em;
            height: 4em;
            path {
                vector-effect: non-scaling-stroke;
            }
        }
    }

    .one-choice {
        flex: 1;
    }

    .text-underline {
        text-decoration: underline;
        transition: all .3s ease-in-out;

        &:hover {
            text-decoration: none;
        }
    }

    .shape,
    .thickness {
        border: 4px solid $gris!important;

        span {
            border-radius: 0 0 5px 5px!important;
        }

        .bg-gris {
            transition: all .15s ease-in-out;
        }

        @media (min-width: 990px) {
            &:hover {
                border: 4px solid $jaune!important;

                .bg-gris {
                    background: $jaune;
                    font-weight: bold;
                }
            }
        }
    }

    #total {
        color: $gristext;
    }

    .bg-rose {
        background: $rose;
    }

    .btn span {
        display: block;
        padding: .55rem 1rem;
    }

    .border-gris-pro {
        border: 3px solid $grispro;
        border-radius: 10px;
        outline: none;
    }

    .btn {
        border-radius: 10px;
        display: inline-block;
        text-align: center;
        white-space: nowrap;
        position: relative;
        cursor: pointer;
        transition: .3s ease-out;

        span {
            display: block;
            position: relative;
            overflow: hidden;
            z-index: 9;
            text-decoration: none;
            padding: .55rem 1rem;
            border-radius: 10px;

            &:after {
                content: "";
                width: 150%;
                height: 0;
                padding-top: 150%;
                object-fit: contain;
                position: absolute;
                top: 50%;
                left: 50%;
                margin: -75%;
                opacity: 1;
                border-radius: 50%;
                transform: scale(0) translateZ(0);
                transition: transform .2s ease-out;
                z-index: -1;
            }
        }

        a {
            text-decoration: none;
        }

        &:hover {
            span:after {
                transform: scale(1) translateZ(0);
                transition: transform .3s ease-in;
            }
        }
    }

    .btn-vert {
        background-color: $vert!important;

        span {
            color: #fff;

            &:after {
                background-color: #1fad59;
            }
        }

        &:hover {
            box-shadow: 0 0 0 0.2rem rgb(37 203 104 / 50%);
        }
    }

    .btn-rouge {
        background-color: $rouge;
    }

    .btn-jaune {
        background-color: $jaune!important;

        span {
            color: #fff;

            &:after {
                background-color: #db9b00;
            }
        }

        &:hover {
            box-shadow: 0 0 0 0.2rem rgba($jaune,.5);
        }
    }

    .btn-white {
        background-color: $white!important;

        span {
            color: $dark;

            &:after {
                background-color: #d3d3d3;
            }
        }

        &:hover {
            box-shadow: 0 0 0 0.2rem rgba($white,.5);
        }
    }

    .articleBox {
        select {
            border: none;
        }
    }





    .ok {
        .choice {
            position: relative;
        }
    }

    .choice-element {
        span {
            line-height: 1!important;
        }
    }

    .bg-gris-pro {
        background: $grispro;;
    }
    .bg-gris {
        background: $gris;
    }
    .bg-jaune {
        background: $jaune;
    }

    .text-white {
        color: $white;
    }
    .text-violet {
        color: $violet;
    }

    .rounded-10 {
        border-radius: 10px!important;
    }
    .rounded-top-10 {
        border-radius: 10px 10px 0 0;
    }
    .rounded-bottom-10 {
        border-radius: 0 0 10px 10px;
    }
    .rounded-right-10 {
        border-radius: 0 10px 10px 0;
    }
    .qty {
        border-radius: 0 10px 0 10px;
    }

    #thickness .img {
        border-top: 3px solid $gris;
        border-left: 3px solid $gris;
        border-right: 3px solid $gris;
    }
</style>
